import { assert_false } from '@shared/asserts/utils_asserts';
import { ENUM__ml_asset_family } from '@shared/dto/+model/sd/_enums/ENUM__ml_asset_family';
import { MAP_OF_MAP__fields_store } from '@shared/types/types';
import { FIELD__base } from '../../_fields/_base/FIELD__base';
import { DTO_GRAPH__instance } from '../DTO_GRAPH__instance';

declare module '../DTO_GRAPH__instance' {
  interface DTO_GRAPH__instance {
    fields_store__save_to(fields_store: MAP_OF_MAP__fields_store): void;

    fields_store__fill_from(fields_store: MAP_OF_MAP__fields_store): void;
  }
}

export function INIT_EXTENSION_DTO_GRAPH__instance__fields_store() {
  //do nothing
}

DTO_GRAPH__instance.prototype.fields_store__save_to = function (fields_store: MAP_OF_MAP__fields_store): void {
  let fields_map = this.fields__get_map();

  /*
   *
   */

  let fields_to_store = fields_map.values().filter(field => field.meta.store__write_is_enabled());

  fields_to_store = fields_to_store.filter(field => !field.is_stub());
  fields_to_store = fields_to_store.filter(field => field.meta.kind__is_input);

  let [fields__with_effect, fields__without_effect]: [FIELD__base[], FIELD__base[]] = [[], []];

  for (let field of fields_to_store) {
    let has_effect = this.node_and_field__has_effect_on_generation_runtime(field);

    has_effect ? fields__with_effect.push(field) : fields__without_effect.push(field);
  }

  /*
   * ADD TO STORE
   */

  for (let field of fields__with_effect) {
    let family = field.meta.store__get_family();

    let fields_by_family = fields_store.get_or_create_map(family);

    let field_source = field.find_source(this);

    let key = field.meta.store__get_key();

    let data = field_source.store__serialize(this);

    if (data.is_stub()) continue;
    if (data.is_empty()) debugger;

    fields_by_family.set(key, data);
  }

  /*
   * REMOVE FROM STORE
   */

  for (let field of fields__without_effect) {
    let family = field.meta.store__get_family();

    if (!fields_store.has(family)) continue;

    let fields_by_family = fields_store.get_or_create_map(family);

    let key = field.meta.store__get_key();

    if (!fields_by_family.has(key)) continue;

    fields_by_family.delete(key);
  }
};

DTO_GRAPH__instance.prototype.fields_store__fill_from = function (fields_store: MAP_OF_MAP__fields_store): void {
  if (fields_store.is_empty()) return;

  let fields_map = this.fields__get_map();

  let fields_list = fields_map.values().filter(field => field.meta.store__read_is_enabled());

  /*
   * LINKED
   */
  for (let field of fields_list) {
    if (!field.meta.data__is_linked) continue;

    let field_source = field.find_source(this);
    let [family, share_key] = [field.meta.store__get_family(), field.meta.store__get_key()];

    FN_FIELD__deserialize(field_source, family, share_key, fields_store);
  }

  /*
   * NOT LINED
   */

  for (let field of fields_list) {
    if (field.meta.data__is_linked) continue;

    let [family, share_key] = [field.meta.store__get_family(), field.meta.store__get_key()];

    FN_FIELD__deserialize(field, family, share_key, fields_store);
  }
};

function FN_FIELD__deserialize(field: FIELD__base, family: ENUM__ml_asset_family, share_key: string, fields_store: MAP_OF_MAP__fields_store) {
  if (field.meta.kind__is_output) return;
  assert_false(field.meta.data__is_linked);

  let fields_by_family = fields_store.get_or_create_map(family);
  if (!fields_by_family.has(share_key)) return;

  let data = fields_by_family.get_or_assert(share_key);

  field.store__deserialize(data);
}
